import { ReportTemplateList } from './ReportTemplateList';

export default ReportTemplateList;
